export default function exampleUploadPas() : string
{
    return (
        "yellow,UNK,S,40.52748474,-76.22362968,399.339606\n" +
        "yellow,S,UNK,40.53038212,-76.22225171,375.0384209\n" +
        "yellow,UNK,S,40.53091065,-76.22138162,367.5932447\n" +
        "yellow,S,UNK,40.53197291,-76.22067131,357.8682265\n"
    )
}
